@if (showContent && this.inComparePage) {
  <div class="compare-block" [ngClass]="iconToggler ? 'toggler-up' : 'toggler-down'"
    >
    <div class="row">
      <div class="col-xs-12 col-sm-5 col-md-7 col-lg-8 compare-box-mobile">
        <div class="compare-block-title">
          <div class="col-md-5">{{'common.compare_product_note_footer_compare'|cxTranslate}}</div>
          @if (isMobile) {
            <span (click)="iconToggler = !iconToggler" class="span-icon"><img
              [attr.src]=" iconToggler ? '/icons/arrow-up-white.svg' : '/icons/arrow_down-white.svg'" alt=""
            style="width: 30px;" srcset=""></span>
          }
          <div class="comapre-error">{{'common.compare_product_note_footer'|cxTranslate}}</div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-5 col-lg-4">
        <div class="compare-block-right-block">
          <button class="compare-clearall mr-2"
          (click)="deleteAll()">{{'common.compare_product_note_footer_clear_all'|cxTranslate}}</button>
          <button class="compare-products" (click)="goToCompare()">
            {{'common.compare_product_note_footer_compare'|cxTranslate}}
            <img src="/icons/link-dark-grey.svg" style="width: 15px;" alt="">
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="container">
          @if (prodData.length !== 0) {
            <div class="row compare-row">
              @for (prod of prodData; track prod) {
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3 compare-box">
                  <div class="compare-inside-box">
                    <div class="compare-overlay-thumb">
                                <a [attr.aria-label]="
                                !prod.images?.hasOwnProperty('PRIMARY')
                                  ? ('productDetails.noProductImage'
                                    | cxTranslate: { product: prod.name })
                                  : undefined
                              " [routerLink]="{cxRoute:'product',params:prod}|cxUrl"
                        class="cx-product-image-container">
                        <cx-media class="cx-product-image"
                          [container]="prod.images?.PRIMARY || prod.images[1]" format="product"
                        [alt]="prod.name || prod.summary"></cx-media>
                      </a>
                    </div>
                    <div class="compare-overlay-box"><span class="compare-pd-id"
                    [routerLink]="{cxRoute:'product',params:prod}|cxUrl">{{prod.code}}</span><span
                    class="compare-pd-code"
                  [routerLink]="{cxRoute:'product',params:prod}|cxUrl">{{prod.typenumber}}</span>
                  <span [routerLink]="{cxRoute:'product',params:prod}|cxUrl"
                  class="compare-pd-name">{{prod.name}}</span>
                </div>
                <div class="compare-box-close remove-comp-product">
                  <img src="/icons/close-light-grey.svg" (click)="removeData(prod.code)" alt="Remove Data">
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
</div>
}